
import ModalImageGallery from "./modal-image-gallery";
export default ModalImageGallery